import React from 'react';
import LoadingSkeleton from '../Shared/LoadingSkeleton';

// Added isLoading and error props
const SearchHistory = ({ history, onHistoryItemClick, isLoading, error }) => {
  return (
      // Use flex-col and define a height (e.g., h-[400px] or adjust based on sibling)
      // min-h-[200px] is okay for initial state, but we need a max-height or fixed height for scrolling
      <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-lg transition-medium transform-gpu hover:scale-[1.005] border border-dark-400 hover:border-accent-purple/30 flex flex-col h-[400px]"> {/* Example fixed height */}
          {/* Header - Keep outside scrollable area */}
          <h3 className="font-bold text-lg mb-4 flex items-center flex-shrink-0">
              <i className="fas fa-history mr-2 text-accent-purple"></i>
              Recent Searches
              {isLoading && <i className="fas fa-spinner fa-spin text-xs ml-2 text-gray-400"></i>}
          </h3>

          {/* Scrollable Content Area - Use flex-1 to fill remaining space and add overflow */}
          <div className="flex-1 overflow-y-auto custom-scrollbar pr-2 space-y-3">
              {isLoading ? (
                  // Show skeleton inside the scrollable area
                  <LoadingSkeleton count={5} />
              ) : error ? (
                  // Show error inside the scrollable area
                  <div className="flex items-center justify-center h-full">
                    <p className="text-center text-accent-red text-sm">{error}</p>
                  </div>
              ) : history.length === 0 ? (
                 // Show empty message inside the scrollable area, centered
                 <div className="flex items-center justify-center h-full">
                    <p className="text-gray-400 text-center">No recent searches</p>
                 </div>
              ) : (
                  // Render history items inside the scrollable area
                  history.map((item, index) => (
                      <div
                          key={item.username + index} // Use more unique key if possible
                          className="bg-dark-500 rounded-lg p-3 flex items-center hover:bg-dark-400 transition cursor-pointer transform-gpu hover:-translate-y-0.5 hover:shadow-md"
                          onClick={() => onHistoryItemClick(item.username)}
                      >
                          <div className="w-8 h-8 rounded bg-dark-400 overflow-hidden mr-3 flex-shrink-0 hover:rotate-3 transition-medium">
                              <img src={item.avatar || 'https://minotar.net/avatar/steve/32'} // Provide fallback
                                   alt={`${item.username}'s Avatar`}
                                   className="w-full h-full minecraft-avatar hover:scale-110 transition-medium"
                                   onError={(e) => { e.target.onerror = null; e.target.src='https://minotar.net/avatar/steve/32'; }} />
                          </div>
                          <div className="flex-1 overflow-hidden"> {/* Added overflow-hidden */}
                              <div className="font-medium text-sm hover:text-accent-purple transition-medium truncate">{item.username}</div> {/* Added truncate */}
                              <div className="text-xs text-gray-400 hover:text-gray-300 transition-medium">{item.results} results • {item.time}</div>
                          </div>
                          <div className="w-6 text-center">
                              <i className="fas fa-chevron-right text-gray-500 text-xs hover:text-accent-purple hover:scale-125 transition-medium"></i>
                          </div>
                      </div>
                  ))
              )}
          </div>

          {/* Optional Footer (if needed later) - Keep outside scrollable area */}
          {/* {history.length > 0 && !isLoading && !error && (
            <div className="mt-4 text-center flex-shrink-0 pt-4 border-t border-dark-500">
              <button className="text-xs text-accent-purple hover:underline">View Full History</button>
            </div>
           )} */}
      </div>
  );
};

export default SearchHistory;